import * as React from 'react'
import { MatchPairProps } from '../typings'
import { LeftCard } from '../atoms'
import { RightCard } from './RightCard'

import Box from '@mui/material/Box'

export const ServiceLocationMatch: React.FC<MatchPairProps> = (props) => {
  const {
    styles,
    location: { id },
    state: { matches },
  } = props

  const match = React.useMemo(() => matches.get(id), [id, matches])

  return (
    <Box sx={styles.matchPair}>
      <LeftCard {...props} matched={!!match} />
      <RightCard {...props} match={match} />
    </Box>
  )
}
ServiceLocationMatch.displayName = 'ServiceLocationMatch'
